<template>
	<!-- Collapsed and onMobile control the padding of content relative to sidebar -->
	<div
		id="app"
		class="pad-sidebar"
		:class="[{ collapsed: collapsed }, { onmobile: isOnMobile }]"
	>
		<div
			v-tooltip="{
				placement: 'right',
				allowHTML: true,
				content: 'Toggle sidebar (<kbd>[</kbd>)'
			}"
			class="sidebar-collapse"
			@click="
				collapsed = !collapsed;
				toggleSidebar(collapsed);
			"
		>
			<i
				style="font-size: xx-large;"
				:class="collapsed ? 'pi pi-angle-right' : 'pi pi-angle-left'"
			/>
		</div>
		<sidebar-menu
			:menu="menu"
			:collapsed="collapsed"
			theme="white-theme"
			@toggle-collapse="onToggleCollapse"
			width="300px"
			class="sidebar"
			:showOneChild="true"
		/>
		<div
			v-if="isOnMobile && !collapsed"
			class="sidebar-overlay"
			@click="collapsed = true"
		/>

		<!-- If methodsRecord exists render small logo and toolbar -->
		<div class="p-grid p-ai-center">
			<div class="p-col-12 p-md-2 p-lg-1">
				<img class="logo" alt="Logo" :src="getLogoPath()" height="50px" />
			</div>
			<div class="p-col-12 p-md-10 p-lg-10">
				<TheArticleToolbar />
			</div>
			<div class="p-col-12 p-md-10 p-lg-1">
				<button id="tooltip-help" @click="openHelp" class="help-btn">Help</button>
				<b-tooltip target="tooltip-help" triggers="hover" placement="left">
					<div class="tooltip-content">
					<h6>Click here to see help page</h6>
					</div>
				</b-tooltip>
			</div>
		</div>

		<div class="p-shadow-10 p-m-2" style="padding:20px">
			<ProjectEdit class="p-input-filled" />
		</div>
		<div v-if="showHelpFrame">
			<HelpFrame @close="closeHelpFrame()" />
		</div>
	</div>
</template>

<script>
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primevue/resources/themes/bootstrap4-light-blue/theme.css";
import "primevue/resources/primevue.min.css";

import TheArticleToolbar from "./components/TheArticleToolbar.vue";
import ProjectEdit from "./components/ProjectEdit.vue";
import projectTemplateImport from "@/helpers/projectTemplateImport.js";

import VTooltip from "v-tooltip";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import startCase from "lodash/startCase";
import HelpFrame from "./components/HelpFrame";

export default {
	name: "App",
	components: {
		TheArticleToolbar,
		ProjectEdit,
		HelpFrame
	},
	directives: {
		tooltip: VTooltip
	},
	async mounted() {
		this.onResize();
		window.addEventListener("resize", this.onResize);
		// Initialize menu
		this.updateMenu();
	},
	methods: {
		onToggleCollapse(collapsed) {
			this.collapsed = collapsed;
		},
		toggleSidebar(collapsed) {
			this.collapsed = collapsed !== undefined ? collapsed : !this.collapsed;
			document.body.classList.toggle("sidebar-collapsed", this.collapsed);
			document.body.classList.toggle("sidebar-full", !this.collapsed);

			// globalThis.localStorage.setItem('sidebarCollapsed', this.collapsed ? 1 : 0)
		},
		onResize() {
			if (window.innerWidth <= 767) {
				this.isOnMobile = true;
				this.collapsed = true;
			} else {
				this.isOnMobile = false;
				this.collapsed = false;
			}
		},
		async updateMenu() {
			const { getMenu } = await projectTemplateImport();
			this.menu = getMenu(this.$store.state.projectId);
		},
		pascalCaseTitle() {
			return upperFirst(camelCase(process.env.VUE_APP_PROJECT));
		},
		getLogoPath() {
			return require("./assets/" + process.env.VUE_APP_PROJECT + ".png");
		},
		closeHelpFrame() {
			this.showHelpFrame = false;
		},
		openHelp() {
			console.log("Project Type",process.env.VUE_APP_PROJECT)
			const projectTemplate= process.env.VUE_APP_PROJECT;
			const helpUrls = {
				"methods-wizard": "https://tera-tools.com/help/review-wizard",
				"trial-wizard": "https://tera-tools.com/help/trial-wizard",
				"audit-wizard": "https://tera-tools.com/help/audit-wizard",
				"scoping-wizard": "https://tera-tools.com/help/scoping-wizard",
				"academy-wizard": "https://tera-tools.com/help/academy-wizard"
			};
			const url = helpUrls[projectTemplate] || "https://tera-tools.com/help/methods-wizard";
			window.open(url, "_blank");
		},
	},
	data() {
		return {
			collapsed: false,
			isOnMobile: false,
			menu: [],
			showHelpFrame: false
		};
	},
	watch: {
		projectId: async function() {
			// Update menu
			this.updateMenu();
		},
		$route() {
			// Tell TERA-fy to restore to this page on refresh (only applies when this site is an embed within tera-tools.com)
			this.$tera.setPage({
				path: this.$route.path,
				title: startCase(this.$route.name),
			});
		},
		"$tera.project.TrialWizard.helpToggle"() {
			this.showHelpFrame = true;
		}
	},
	computed: {
		projectId() {
			return this.$store.state.projectId;
			//return this.$tera.project.id;
		},
		methodsRecord() {
			return this.$store.state.methodsRecord;
			//return this.$tera.project.methodsRecord;
		}
	}
};
</script>

<style>
/* body {
	background-color: #ffffff;
} */
/* Sidebar body.sidebar-full / body.sidebar-collapsed {{{ */
body {
	background-color: #ffffff;
	--sidebar-width: 300px;

	&.sidebar-full {
		--sidebar-width: 300px;
	}

	&.sidebar-collapsed {
		--sidebar-width: 50px;
	}
}

.logo {
	display: block;
	margin: auto;
}

.logo-text-small {
	padding-left: 20px;
	font-size: 3em;
}

.logo-text-large {
	padding-left: 20px;
	font-size: 5em;
}

.toolbar {
	padding: 0px 20px 20px 20px;
}

.v-sidebar-menu {
	background-color: #ffffff !important;
	/* background-image: linear-gradient(#536fab, white); */
	background-image: linear-gradient(#6880b5, #465b8b, #5971a5);
	/* color: #e3e4e8; */
}

.vsm--header {
	color: #e3e4e8 !important;
}

.vsm--title {
	color: #e3e4e8 !important;
}

.vsm--link_active {
	background-color: rgba(255, 255, 255, 0.3) !important;
}

.vsm--link {
	color: #f9fafb !important;
}

/* .vsm--link_mobile-item:hover {
	background-color: rgba(255, 255, 255, .3) !important;
	color: #fd3411 !important;
} */

.vsm--icon {
	background-color: transparent !important;
}

.vsm--toggle-btn {
	background-color: #647bae !important;
	color: #f2f2f2 !important;
	display: none !important;
}

.pad-sidebar {
	/* Padding left for sidebar */
	padding-left: 300px;
}

#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	/* text-align: center; */
	color: #2c3e50;
	transition: 0.3s ease;
}

#app.collapsed {
	padding-left: 50px;
}

#app.onmobile {
	padding-left: 50px;
}

.sidebar-overlay {
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background-color: #000;
	opacity: 0.5;
	z-index: 900;
}

/* width */
::-webkit-scrollbar {
	width: 7px;
}

/* Track */
::-webkit-scrollbar-track {
	box-shadow: inset 0 0 5px grey;
	border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
	/* background: #536fab;  */
	background: #7f8daf;
	border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
	background: #536fab;
}

&.collapsed {
	& .label {
		display: none;
	}

	& .sidebar-header-logo {
		width: 40px !important;
		height: 40px !important;
		margin-left: -4px;
	}
}

& .sidebar-collapse {
	position: fixed;
	left: calc(var(--sidebar-width) - 30px);
	bottom: 80px;
	width: 50px;
	height: 50px;
	z-index: 1000;
	transform: scale(0);
	opacity: 0;

	display: flex;
	align-items: center;
	justify-content: center;

	background: #5c7cc0;
	border-radius: 50%;
	box-shadow: 0 0 5px rgba(0, 0, 0, 0.3333333333);

	color: #fff;
	font-size: x-large;

	cursor: pointer;

	transition: all 0.3s ease;
}

.pad-sidebar:hover .sidebar-collapse {
	transform: scale(1);
	opacity: 1;
	background: #5c7cc0;
}

/* &:hover .sidebar-collapse {
	transform: scale(1);
	opacity: 1;
	background: #5c7cc0;
} */
/* .ag-theme-quartz, */
/* .ag-theme-quartz-dark { */
	/* Changes the color of the grid text */
	/* --ag-foreground-color: rgb(14, 68, 145) !important; */
	/* Changes the color of the grid background */
	/* --ag-background-color: rgb(241, 247, 255) !important; */
	/* Changes the header color of the top row */
	/* --ag-header-background-color: rgb(228, 237, 250) !important; */
	/* Changes the hover color of the row*/
	/* --ag-row-hover-color: rgb(216, 226, 255) !important; */
/* } */
.ag-theme-quartz .ag-header-cell-label {
	font-family: Arial, Helvetica, sans-serif;
}
.ag-theme-quartz .ag-cell-value-label {
	font-family: Arial, Helvetica, sans-serif;
}
.help-btn {
  border-radius: 20px;
  width: 90px;
  margin-left: 6px;
  background-color: #21a5d5;
  color: white;
  border: none;
  outline: none;
  padding: 6px 12px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}

/* hover effect */
.help-btn:hover {
  background-color: #1b8bb5;
}

/* optional: active click feel */
.help-btn:active {
  transform: scale(0.97);
}

/* tooltip width fix */
.tooltip-inner {
  max-width: 300px !important;
}

.tooltip-content {
  width: 300px;
}
</style>
